module.exports = __webpack_public_path__ + "img/middlepic02.1d17f78a.jpg";